import React, { useEffect, useState } from "react";
import { createMuiTheme } from '@material-ui/core/styles'

import Form from "@Components/Form";
import {
  ID_TYPES_URL,
  URLS,
  WORKER_URL,
  WORKER_TYPES_URL,
  WORKER_QR_URL,
  ZONE_FETCH_URL,
  REGION_FETCH_URL,
  ESTATE_FETCH_URL,
  DIVISION_FETCH_URL,
  BLOCK_FETCH_URL,
  LIST_WORKER_GROUP_URL,
  NATIONALITIES_LIST_URL,
  PASSPORT_STATUS_URL,
  PASSPORT_RENEWAL_STATUS_URL,
  PERMIT_STATUS_URL,
  PERMIT_RENEWAL_STATUS_URL
} from "configs/constants";
import * as Yup from "yup";
import eightAxios from "../../configs/axiosConfig";
import { SOURCE_FETCH_URL } from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";



const validationSchema = Yup.object({
  employee_id: Yup.string()
    .required("Employee id is required")
    .typeError("Invalid employee id"),
  name: Yup.string()
    .required("Worker name is required")
    .typeError("Invalid employee name"),
  source: Yup.string()
    .required("Source is required")
    .typeError("Invalid source name")
    .nullable(),

  company: Yup.string()
    .required("Company is required")
    .typeError("Invalid company name")
    .nullable(),
  id_type: Yup.string()
    .required("ID type is required")
    .typeError("Invalid id type")
    .nullable(),
  id_number: Yup.string()
    .required("ID Number is required")
    .typeError("Invalid ID Number"),
  nationality: Yup.string()
    .required("Nationality is required")
    .typeError("Invalid nationality"),
  mobile_number: Yup.string()
    .required("Mobile Number is required")
    .matches(/^[0-9]+$/, "Mobile Number must contain only digits")
    .matches(/^\S*$/, "Spaces at the beginning or end are not allowed")
    .min(8, "Invalid length Min 10, Max 12")
    .max(12, "Mobile Number must not exceed 12 digits")
    .typeError("Invalid mobile number"),
  worker_group: Yup.string()
    .required("Worker group is required")
    .typeError("Invalid worker group")
    .nullable(),
  zone: Yup.string()
    .required("Zone is required")
    .typeError("Invalid Zone")
    .nullable(),
  region: Yup.string()
    .required("Region is required")
    .typeError("Invalid Region")
    .nullable(),
  estate: Yup.string()
    .required("Estate is required")
    .typeError("Invalid Estate")
    .nullable(),
});

const WorkerEditForm = () => {
  const [selectedWorkerGroup, setSelectedWorkerGroup] = useState(null);
  const [supervisor, setSupervisor] = useState("");
  const [selectedWorkerType, setSelectedWorkerType] = useState('');
  const [showDocuments, setShowDocuments] = useState(false);
  const [selectedErmlType,setSelectedErmlType] =useState(false);
  const [disableswitch,setDisableswitch] = useState(false);
  const [selectedIdType, setSelectedIdType] = useState("");
  const [selectedNationalityType,setSelectedNationalityType] =useState('');
  const [disabledWorkerType,setDisabledWorkerType] = useState(false);
  const [disabledNationalityType,setDisabledNationalityType] = useState(false);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [disableCompany, setDisableCompany] = useState(true);
  const [disableZone, setDisableZone] = useState(true);


  const getZoneValues = (e,setDisableRegion) => {
  //  if (!e || e.length === 0) {
    if (!e || e.length === 0 || e.label == "N/A") {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };
  const getSourceValue = (e,setDisableCompany) => {
    if (!e || e.length === 0) {
      setDisableCompany(true);
    }
    else {
      setDisableCompany(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };

  const getEstateValues = (e,setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
    
  };
  const getDivisonValues = (e,setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
    
  };
  
  useEffect(() => {
  
    if (selectedWorkerType == "Foreign") {
      setShowDocuments(true);
    }
    else {
      setShowDocuments(false);
    }
    if (selectedWorkerGroup) {
      eightAxios
        .get(`supervisor-assignment/${selectedWorkerGroup}/get-supervisor/`)
        .then((res) => {
          setSupervisor(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      setSupervisor(null);
    }
  }, [selectedWorkerGroup, selectedWorkerType]);
  
  const getErmlType = (e) => {

    setDisableswitch(true);

    setSelectedErmlType(e?.value);

  };


  const getIdType = (e) => {
    if(e?.label == "IC" ){      
      setSelectedIdType(e?.value)
      setDisabledWorkerType(true);
      setSelectedWorkerType("Local");
      setSelectedNationalityType("Malaysia");
      setDisabledNationalityType(true);
    }
    if(e?.label == "PASSPORT" ){
      setSelectedIdType(e?.value)
      setDisabledWorkerType(true);
      setSelectedWorkerType("Foreign");
      setSelectedNationalityType('');
      setDisabledNationalityType(false);
    }

  };

  const getNationalityType = (e) => {
    console.log('e',e)

    //setSelectedNationalityType(e?.value);
  };
  const getWorkerGroup = (e) => {
    setSelectedWorkerGroup(e?.value);
  };

  const getWorkerType = (e) => {
    console.log("eeee",e)
    // setSelectedWorkerType(e?.value);

  }

  const initialValues = {
    api:false,
    id_type: "",
    id_number: "",
    
    name: "",
    username: "",
    role: [5],
    mobile_number: "",
    employee_id: "",
    status: "Pending",
    zone: "",
    source: "",
    company: "",
    region: "",
    estate: "",
    division: "",
    block: "",
    nationality: "",
    is_mobile_user: "",
    worker_type:"",
    passport_start_date: "",
    passport_expiry_date: "",
    passport_status: "",
    passport_renewal_status: "",
    passport_renewal_start_date: "",
    permit_number: "",
    permit_start_date: "",
    permit_expiry_date: "",
    permit_status: "",
    permit_renewal_status: "",
    permit_renewal_start_date: "",
    contract_start_date: "",
    contract_expiry_date: "",
  };

  const formFields = [
    { type: "title", title: "Personal Details" },
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type:
      //  selectedErmlType?"renderonly":
      "input",
      name: "name",
      key: "name",
      label: "Full Name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      type: 
      // selectedErmlType?"renderonly":
      "reactselect",
      name: "id_type",
      key: "id_type",
      getValue: getIdType ,
      label: "ID Type",
      required: true,
      proxyUrl: ID_TYPES_URL,
      paginated: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    
    {
      type: 
      // selectedErmlType?"renderonly":
      "input",
      name: "id_number",
      label: "ID Number",
      key: "id_number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      type:
      // selectedErmlType?"renderonly": 
      "reactselect",
      name: "nationality",
      label: "Nationality",
      key: "nationality",
      value:selectedNationalityType,
      optionsDependsOn:'id_type',
      required: true,
      proxyUrl: NATIONALITIES_LIST_URL,
      disabled:disabledNationalityType,
      paginated: false,
      groupedOptions: true,
      getValue: getNationalityType,
     gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type:
      // selectedErmlType?"renderonly": 
      "reactselect",
      name: "worker_type",
      label: "Worker Type",
      key: "worker_type",
      optionsDependsOn:'id_type',
      value:selectedWorkerType,
      required: true,
      proxyUrl: WORKER_TYPES_URL,
      paginated: false,
      disabled:disabledWorkerType,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      getValue: getWorkerType,
    },
    
    {
      type: 
      // selectedErmlType?"renderonly":
      "phone",
      name: "mobile_number",
      label: "Mobile Number",
      key: "mobile_number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    
    {
      type: "imagerender",
      label: "QR Code",
      name: "qr_code",
      key: "qr_code",
      altValue: "worker qr code",
      enableDownload: true,
      enablePrint: true,
      downloadUrl: WORKER_QR_URL,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      name: "api",
      key:"api",
      type: "switch",
      label: "API",
      disabled:disableswitch,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },

      color: "primary",
      nolabel: "No",
      yeslabel: "Yes",
      getValue: getErmlType,




    },
    {
      type: "reactselect",
      name: "source",
      label: "Source",
      proxyUrl: SOURCE_FETCH_URL,
      required:true,
      getValue: (e) => getSourceValue(e, setDisableCompany),
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },

      paginated: true,
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      required:true,
      paginated: true,
      disabled:disableCompany,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      optionsDependsOn: "source",
      getValue: (e) => getCompanyValues(e, setDisableZone),

    },

    { type: "title", title: "Employment Details" },
    {
      type: 
      // selectedErmlType?"renderonly":
      "reactselect",
      name: "status",
      key: "status",
      label: "Status",
      outerOptions: [
        { id: "Active", name: "Active" },
        { id: "Inactive", name: "Inactive" },
      ],
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      required:true,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      optionsDependsOn: "company",
      disabled: disableZone,

    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      required:true,

      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      required:true,

      paginated: true,
      disabled:disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),

      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
    {
      type: 
      // selectedErmlType?"renderonly":
      "reactselect",
      name: "worker_group",
      label: "Worker Group",
      key: "worker_group_name",
      required: true,
      proxyUrl: LIST_WORKER_GROUP_URL,
      paginated: false,
      optionsDependsOn: "estate",
      filterOnType: true,
      getValue: getWorkerGroup,
    },
    {
      type: "renderonly",
      name: "supervisor_name",
      key: "supervisor_name",
      label: "Supervisor",
    //  value: supervisor?.name,
      required: false,
    },
    { type: "title", title: "Document Details", showField: showDocuments },
    {
      type: 
      // selectedErmlType?"renderonly":
      "datepicker",
      size: "small",
      helperText: "",
      name: "passport_start_date",
      key: "passport_start_date",

      label: "Passport Start Date",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type:
      //  selectedErmlType?"renderonly":
       "datepicker",
      name: "passport_expiry_date",
      key: "passport_expiry_date",
      autoComplete: "off",
      size: "small",
      helperText: "",
      label: "Passport Expiry Date",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: 
      // selectedErmlType?"renderonly":
      "reactselect",
      name: "passport_status",
      label: "Passport Status",
      key: "passport_status",
      size: "small",
      proxyUrl: PASSPORT_STATUS_URL,
      paginated: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: 
      // selectedErmlType?"renderonly":
      "reactselect",
      name: "passport_renewal_status",
      label: "Passport Renewal Status",
      key:"passport_renewal_status",
      size: "small",
      proxyUrl: PASSPORT_RENEWAL_STATUS_URL,
      paginated:true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments,
      //  required: true,
    },
    {
      type:
      // selectedErmlType?"renderonly": 
      "datepicker",
      name: "passport_renewal_start_date",
      key: "passport_renewal_start_date",

      autoComplete: "off",
      size: "small",
      helperText: "",
      label: "Passport Renewal Start Date",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    
    {
      type:
      // selectedErmlType?"renderonly":
       "input",
      name: "permit_number",
      key: "permit_number",
      label: "Permit Number",
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: 
      // selectedErmlType?"renderonly":
      "datepicker",
      name: "permit_start_date",
      key: "permit_start_date",
      label: "Permit Start Date",
      autoComplete: "off",
      size: "small",
      helperText: "",
      
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type:
      //  selectedErmlType?"renderonly":
       "datepicker",
      name: "permit_expiry_date",
      key: "permit_expiry_date",
      label: "Permit Expiry Date",
      autoComplete: "off",
      size: "small",
      helperText: "",
      
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    
    
    {
      type: 
      // selectedErmlType?"renderonly":
      "reactselect",
      name: "permit_status",
      key: "permit_status",
      label: "Permit Status",
      size: "small",
      proxyUrl: PERMIT_STATUS_URL,
      paginated:true,
      
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type:
      //  selectedErmlType?"renderonly":
       "reactselect",
      name: "permit_renewal_status",
      key: "permit_renewal_status",
      label: "Permit Renewal Status",
      proxyUrl: PERMIT_RENEWAL_STATUS_URL,
      paginated:true,
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: 
      // selectedErmlType?"renderonly":
      "datepicker",
      name: "permit_renewal_start_date",
      key: "permit_renewal_start_date",
      label: "Permit Renewal Start Date",
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type:
      //  selectedErmlType?"renderonly":
       "datepicker" ,
      name: "contract_start_date",
      key: "contract_start_date",
      label: "Contract Start Date",
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type:
      // selectedErmlType?"renderonly": 
      "datepicker",
      name: "contract_expiry_date",
      key: "contract_expiry_date",
      label: "Contract Expiry Date",
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
  ];

  const formButtons = ["submit", "cancel"];

  return (
    <Form
      validationSchema={validationSchema}
      initialValues={initialValues}
      submitUrl={WORKER_URL}
      listRoute={URLS.WORKER_LIST}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Worker"
    />
  );
};

export default WorkerEditForm;


